<div
	fxLayout="column"
	ngClass.gt-md="p-xxl m-t-xl m-b-xl"
	ngClass.md="p-xl m-b-xl m-t-xl"
	ngClass.sm="p-m m-t-xxl m-b-xxl"
	ngClass.xs="p-m p-t-xxl"
>
	<div
		fxLayout="row"
		fxLayoutAlign="center center"
		fxFlex="100%"
		ngClass="p-b-m"
	>
		<h2
			class="dark-grey-texts text-align-center"
			i18n="@@featured_fundraisers_trendingPersonalCrowdfundingHomePersonal"
		>
			Trending Fundraising Campaigns
		</h2>
	</div>
	<div
		fxFlex="100%"
		fxLayout="row"
		fxLayoutAlign="flex-start center"
		class="homepage-card-container"
		fxHide.lt-sm
	>
		<div
			*ngFor="let _fundraiserCardDataItem of _fundraiserCardDataList"
			class="fundraiser-card"
		>
			<app-fundraiser-card
				id="fundraiser-card"
				name="fundraiser-card"
				[slug]="_fundraiserCardDataItem.slug"
				[fundraiserCardData]="_fundraiserCardDataItem.fundraiserCardData"
			></app-fundraiser-card>
		</div>
	</div>
	<div
		fxFlex="100%"
		fxLayout="column"
		fxLayoutAlign="flex-start center"
		fxLayoutGap="4%"
		fxHide.gt-xs
	>
		<div
			*ngFor="
				let _fundraiserCardDataItem of _fundraiserCardDataList | slice : 0 : 3
			"
			class="fundraiser-card"
		>
			<app-fundraiser-card
				id="fundraiser-card"
				name="fundraiser-card"
				[slug]="_fundraiserCardDataItem.slug"
				[fundraiserCardData]="_fundraiserCardDataItem.fundraiserCardData"
			></app-fundraiser-card>
		</div>
	</div>
	<div
		fxLayout="row"
		fxFlex="100%"
		fxLayoutAlign="space-between flex-end"
		fxLayoutAlign.xs="flex-end"
		ngClass.xs="p-t-xl p-b-xxl"
	>
		<div fxLayout="row" ngClass="p-l-xs p-t-m" fxHide.lt-sm>
			<div
				class="navigation-icon"
				(click)="scrollCards('prev')"
				[ngClass]="{ disabled: !hasMoreData('prev') }"
			>
				<mat-icon class="white-text m-l-xs">arrow_back_ios</mat-icon>
			</div>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
			<div
				class="navigation-icon"
				(click)="scrollCards('next')"
				[ngClass]="{ disabled: !hasMoreData('next') }"
			>
				<mat-icon class="white-text">arrow_forward_ios</mat-icon>
			</div>
		</div>
		<div fxLayout="row">
			<button
				mat-stroked-button
				color="accent"
				class="view_more"
				(click)="routeToSearch()"
				fxFill
			>
				<span
					class="mat-headline-6"
					i18n="@@search_fundraiser_button_title_read_more_button"
					>View More</span
				>
			</button>
		</div>
	</div>
</div>
